export default __webpack_public_path__ + "static/media/avatar-pink-background.0717b72f.svg";